import * as React from 'react';

import { Select } from '@cian/ui-kit';

import { getCurrentTab } from '../../../selectors/tabs';
import { useSelector } from 'react-redux';
import { ETabs } from '../../../types/redux/tabs';
import {
  setDealTypeRealtors,
  setDealTypeAgencies,
  getListingAgencies,
  getListingRealtors,
} from '../../../actions/filters';
import { getDealType } from '../../../selectors/filters';
import { useAppDispatch } from '../../../hooks/useAppDispatch/useAppDispatch';

export enum EDealType {
  Any = 'any',
  Rent = 'rent',
  Sale = 'sale',
}

const options = [
  {
    label: 'Любая сделка',
    value: EDealType.Any,
  },
  {
    label: 'Аренда',
    value: EDealType.Rent,
  },
  {
    label: 'Покупка и продажа',
    value: EDealType.Sale,
  },
];

export function DealTypeContainer() {
  const dispatch = useAppDispatch();

  const currentTab = useSelector(getCurrentTab);
  const dealType = useSelector(getDealType) || EDealType.Any;
  const changeDealType = React.useCallback(
    (dealType: EDealType) => {
      const isRealtorsListing = currentTab === ETabs.Realtors;
      const getListing = isRealtorsListing ? getListingRealtors : getListingAgencies;
      const setDealType = isRealtorsListing ? setDealTypeRealtors : setDealTypeAgencies;
      const correctDealType = dealType === EDealType.Any ? undefined : dealType;

      dispatch(getListing(setDealType, correctDealType));
    },
    [currentTab, dispatch],
  );

  return <Select width={180} onChange={changeDealType} value={dealType} options={options} />;
}
